(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["five-reasons-bedtime"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.er-five').forEach(function(section){
    var gallery=section.querySelector('.er-five__buy-main');
    var mainImage=gallery&&gallery.querySelector('img');
    var thumbnails=Array.from(section.querySelectorAll('.er-five__thumbnail'));
    thumbnails.forEach(function(button){
      button.addEventListener('click',function(){
        if(!mainImage)return;
        mainImage.src=button.dataset.imageUrl;
        mainImage.removeAttribute('srcset');
        mainImage.alt=button.dataset.imageAlt;
        thumbnails.forEach(function(item){item.classList.remove('is-active');item.setAttribute('aria-pressed','false')});
        button.classList.add('is-active');
        button.setAttribute('aria-pressed','true');
      });
    });
    if(gallery&&thumbnails.length>1){
      var pointerStart=null;
      mainImage.draggable=false;
      gallery.addEventListener('pointerdown',function(event){
        if(!event.isPrimary)return;
        pointerStart={id:event.pointerId,x:event.clientX,y:event.clientY};
        gallery.setPointerCapture(event.pointerId);
      });
      gallery.addEventListener('pointerup',function(event){
        if(!pointerStart||event.pointerId!==pointerStart.id)return;
        var distanceX=event.clientX-pointerStart.x;
        var distanceY=event.clientY-pointerStart.y;
        pointerStart=null;
        if(Math.abs(distanceX)<40||Math.abs(distanceX)<=Math.abs(distanceY))return;
        var currentIndex=thumbnails.findIndex(function(button){return button.classList.contains('is-active')});
        var nextIndex=Math.min(thumbnails.length-1,Math.max(0,currentIndex+(distanceX<0?1:-1)));
        if(nextIndex!==currentIndex)thumbnails[nextIndex].click();
      });
      gallery.addEventListener('pointercancel',function(){pointerStart=null});
    }
    var variantSelect=section.querySelector('.er-five__variant-select');
    var variantInput=section.querySelector('.product-variant-id');
    if(variantSelect&&variantInput){variantSelect.addEventListener('change',function(){variantInput.value=variantSelect.value})}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-baby-bedtime"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.er-science').forEach(function(section){
    var gallery=section.querySelector('.er-science__buy-main');
    var mainImage=gallery&&gallery.querySelector('img');
    var thumbnails=Array.from(section.querySelectorAll('.er-science__thumbnail'));
    thumbnails.forEach(function(button){
      button.addEventListener('click',function(){
        if(!mainImage)return;
        mainImage.src=button.dataset.imageUrl;
        mainImage.removeAttribute('srcset');
        mainImage.alt=button.dataset.imageAlt;
        thumbnails.forEach(function(item){item.classList.remove('is-active');item.setAttribute('aria-pressed','false')});
        button.classList.add('is-active');
        button.setAttribute('aria-pressed','true');
      });
    });
    if(gallery&&thumbnails.length>1){
      var pointerStart=null;
      mainImage.draggable=false;
      gallery.addEventListener('pointerdown',function(event){
        if(!event.isPrimary)return;
        pointerStart={id:event.pointerId,x:event.clientX,y:event.clientY};
        gallery.setPointerCapture(event.pointerId);
      });
      gallery.addEventListener('pointerup',function(event){
        if(!pointerStart||event.pointerId!==pointerStart.id)return;
        var distanceX=event.clientX-pointerStart.x;
        var distanceY=event.clientY-pointerStart.y;
        pointerStart=null;
        if(Math.abs(distanceX)<40||Math.abs(distanceX)<=Math.abs(distanceY))return;
        var currentIndex=thumbnails.findIndex(function(button){return button.classList.contains('is-active')});
        var nextIndex=Math.min(thumbnails.length-1,Math.max(0,currentIndex+(distanceX<0?1:-1)));
        if(nextIndex!==currentIndex)thumbnails[nextIndex].click();
      });
      gallery.addEventListener('pointercancel',function(){pointerStart=null});
    }
    var variantSelect=section.querySelector('.er-science__variant-select');
    var variantInput=section.querySelector('.product-variant-id');
    if(variantSelect&&variantInput){variantSelect.addEventListener('change',function(){variantInput.value=variantSelect.value})}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["science-bedtime-routine"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.er-routine').forEach(function(section){
    var gallery=section.querySelector('.er-routine__buy-main');
    var mainImage=gallery&&gallery.querySelector('img');
    var thumbnails=Array.from(section.querySelectorAll('.er-routine__thumbnail'));
    thumbnails.forEach(function(button){
      button.addEventListener('click',function(){
        if(!mainImage)return;
        mainImage.src=button.dataset.imageUrl;
        mainImage.removeAttribute('srcset');
        mainImage.alt=button.dataset.imageAlt;
        thumbnails.forEach(function(item){item.classList.remove('is-active');item.setAttribute('aria-pressed','false')});
        button.classList.add('is-active');
        button.setAttribute('aria-pressed','true');
      });
    });
    if(gallery&&thumbnails.length>1){
      var pointerStart=null;
      mainImage.draggable=false;
      gallery.addEventListener('pointerdown',function(event){
        if(!event.isPrimary)return;
        pointerStart={id:event.pointerId,x:event.clientX,y:event.clientY};
        gallery.setPointerCapture(event.pointerId);
      });
      gallery.addEventListener('pointerup',function(event){
        if(!pointerStart||event.pointerId!==pointerStart.id)return;
        var distanceX=event.clientX-pointerStart.x;
        var distanceY=event.clientY-pointerStart.y;
        pointerStart=null;
        if(Math.abs(distanceX)<40||Math.abs(distanceX)<=Math.abs(distanceY))return;
        var currentIndex=thumbnails.findIndex(function(button){return button.classList.contains('is-active')});
        var nextIndex=Math.min(thumbnails.length-1,Math.max(0,currentIndex+(distanceX<0?1:-1)));
        if(nextIndex!==currentIndex)thumbnails[nextIndex].click();
      });
      gallery.addEventListener('pointercancel',function(){pointerStart=null});
    }
    var variantSelect=section.querySelector('.er-routine__variant-select');
    var variantInput=section.querySelector('.product-variant-id');
    if(variantSelect&&variantInput){variantSelect.addEventListener('change',function(){variantInput.value=variantSelect.value})}
  });

  } catch(e) { console.error(e); }
})();
})();
